import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["burger", "wrapper"]

  static values = {
    overflow: Boolean,
    dynamicPosition: Boolean
  }

  initialize () {
    this.body = document.body
    this.html = document.documentElement
    this.isOpen = false
  }

  connect () {
    if (this.dynamicPositionValue) {
      this.positionWrapper()
      this.observeBanner()
    }
    this.updateDom()
  }

  disconnect () {
    if (this.bannerObserver) {
      this.bannerObserver.disconnect()
    }
  }

  observeBanner () {
    const banner = document.getElementById("banner")
    if (!banner) return

    this.bannerObserver = new MutationObserver(() => {
      this.positionWrapper()
    })

    this.bannerObserver.observe(banner, {
      attributes: true,
      attributeFilter: ["style"]
    })
  }

  positionWrapper () {
    if (!this.hasWrapperTarget) return

    const headerRect = this.element.getBoundingClientRect()
    this.wrapperTarget.style.top = `${headerRect.bottom}px`
  }

  toggle (event) {
    event.preventDefault()
    this.isOpen = !this.isOpen

    if (this.dynamicPositionValue) {
      this.positionWrapper()
    }
    this.updateDom()
  }

  clickOutsideHandler (e) {
    if (!this.element.contains(e.target)) {
      this.isOpen = false
      this.updateDom()
    }
  }

  updateDom () {
    this.element.classList.toggle("active", this.isOpen)

    if (this.hasBurgerTarget) {
      this.burgerTarget.classList.toggle("active", this.isOpen)
    }

    if (this.overflowValue) {
      this.body.classList.toggle("overflow-hidden-body", this.isOpen)
      this.html.classList.toggle("overflow-hidden-html", this.isOpen)
    }
  }
}
